export default "__VITE_ASSET__Qu6LgCk8__"